<form [formGroup]="form" (ngSubmit)="submitted.next()" novalidate>
  <div class="gmb-8">
    <div
      [ngClass]="{
        'd-inline-flex': true,
        'w-100 w-sm-50 gmb-16 gmb-sm-0 gpr-sm-12': true
      }"
    >
      <gpu-form-field
        [appearance]="formFieldAppearance"
        class="gpu-wrapper-reserved"
      >
        <gpu-label>
          {{ 'ANALYSES.SINGLE.RESULT' | translate }}
        </gpu-label>
        <input
          id="value"
          name="value"
          type="text"
          gpuInput
          [focused]="true"
          appMobileScrollOnFocus
          gpuLocalNumber
          [placeholder]="'ANALYSES.SINGLE.VALUE' | translate"
          formControlName="value"
          (blur)="trackInput('value', form.controls.value)"
        />
        <gpu-error
          *ngIf="
            form.controls.value.errors?.required &&
            !form.controls.value.errors?.invalidValue
          "
        >
          {{ 'ANALYSES.VALUE_REQUIRED' | translate }}
        </gpu-error>
        <gpu-error *ngIf="form.controls.value.errors?.pattern">
          {{ 'ANALYSES.VALUE_INVALID' | translate }}
        </gpu-error>
        <gpu-error *ngIf="form.controls.value.errors?.min">
          {{ 'MIN_VALUE' | translate }}
        </gpu-error>
        <gpu-error *ngIf="form.controls.value.errors?.max">
          {{ 'MAX_VALUE' | translate }}
        </gpu-error>
        <gpu-error
          *ngIf="
            form.controls.value.errors?.invalidValue &&
            !form.controls.value.valid
          "
        >
          {{ 'FAILURE.ERROR_CODES.' + errorCodes.INVALID_VALUE | translate }}
        </gpu-error>
      </gpu-form-field>
    </div>

    <div class="d-inline-flex w-100 w-sm-50 gmb-16 gmb-sm-0 gpl-sm-12">
      <gpu-form-field [appearance]="formFieldAppearance">
        <gpu-label>{{ 'ANALYSES.UNIT' | translate }}</gpu-label>
        <gpu-select
          [placeholder]="'ANALYSES.UNIT' | translate"
          formControlName="unit"
        >
          <gpu-option
            *ngFor="let option of configuration.markers[0].units"
            [value]="option.id"
          >
            <span [innerHTML]="option.name | transformUnits"></span>
          </gpu-option>
        </gpu-select>
        <gpu-error *ngIf="form.controls.unit.errors?.required">
          {{ 'ANALYSES.UNIT_REQUIRED' | translate }}
        </gpu-error>
      </gpu-form-field>
    </div>
  </div>

  <div class="gp-alert gp-alert-info p4-regular gmb-16 gmb-md-32">
    {{ 'ANALYSES.SINGLE.REF_TOOLTIP' | translate }}
  </div>

  <div class="gmb-8">
    <gpu-form-field
      [appearance]="formFieldAppearance"
      class="gpu-wrapper-reserved"
    >
      <gpu-label>
        {{ 'ANALYSES.SINGLE.MIN_REF' | translate }}
      </gpu-label>
      <input
        id="min"
        name="min"
        type="text"
        gpuInput
        gpuLocalNumber
        formControlName="from"
        [placeholder]="'ANALYSES.SINGLE.MIN_REF' | translate"
        (blur)="trackInput('from', form.controls.from)"
      />
      <gpu-error *ngIf="form.controls.from?.errors?.required">
        {{ 'ANALYSES.SINGLE.MIN_REFERENCE' | translate }}
      </gpu-error>
      <gpu-error *ngIf="form.controls.from?.errors?.min">
        {{ 'ANALYSES.SINGLE.MIN_REFERENCE_VALUE' | translate }}
      </gpu-error>
      <gpu-error *ngIf="form.controls.from?.errors?.pattern">
        {{ 'ANALYSES.VALUE_INVALID' | translate }}
      </gpu-error>
    </gpu-form-field>
  </div>

  <div class="gmb-8">
    <gpu-form-field
      [appearance]="formFieldAppearance"
      class="gpu-wrapper-reserved"
    >
      <gpu-label>
        {{ 'ANALYSES.SINGLE.MAX_REF' | translate }}
      </gpu-label>
      <input
        id="max"
        name="max"
        type="text"
        gpuInput
        gpuLocalNumber
        formControlName="to"
        [placeholder]="'ANALYSES.SINGLE.MAX_REF' | translate"
        (blur)="trackInput('to', form.controls.to)"
      />
      <gpu-error *ngIf="form.controls.to?.errors?.required">
        {{ 'ANALYSES.SINGLE.MAX_REFERENCE' | translate }}
      </gpu-error>
      <gpu-error *ngIf="form.controls.to?.errors?.max">
        {{ 'ANALYSES.SINGLE.MAX_REFERENCE_VALUE' | translate }}
      </gpu-error>
      <gpu-error *ngIf="form.controls.to?.errors?.pattern">
        {{ 'ANALYSES.VALUE_INVALID' | translate }}
      </gpu-error>
    </gpu-form-field>

    <small
      class="form-text text-danger gpt-8 gpl-16"
      *ngIf="
        form.controls.from.touched &&
        form.controls.to.touched &&
        form.errors?.invalidFromTo
      "
    >
      {{ 'ANALYSES.SINGLE.MIN_LOWER_THAN_MAX' | translate }}
    </small>
  </div>

  <gpu-form-field *ngIf="showDate" [appearance]="formFieldAppearance">
    <gpu-label>
      {{ 'ANALYSES.ADD.DATE' | translate }}
    </gpu-label>
    <input
      id="value-date"
      name="date"
      type="text"
      gpuDatepicker
      ngbDatepicker
      #datepicker="ngbDatepicker"
      container="body"
      formControlName="date"
      [maxDate]="now"
      [minDate]="minDate"
      [datepicker]="datepicker"
      [placeholder]="'ANALYSES.ADD.DATE' | translate"
    />
    <i gpuSuffix class="gpicon-calendar"></i>
    <gpu-error *ngIf="form.controls.date?.errors?.required">
      {{ 'ANALYSES.ADD.REQUIRED' | translate }}
    </gpu-error>
  </gpu-form-field>
  <!-- this is only for "enter" to work as submit -->
  <button type="submit" style="display: none"></button>
</form>
